// extracted by mini-css-extract-plugin
export default {"table":"bank-deposit-list_table__VrzfG","iconCustom":"bank-deposit-list_iconCustom__jAkCv"};